import React from "react";
import PropTypes from "prop-types";
import distanceInWords from "date-fns/distance_in_words";
import addMilliseconds from "date-fns/add_milliseconds";
//Material imports
import Switch from "@mui/material/Switch";
import makeStyles from "@mui/styles/makeStyles";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
//Limitless imports
import { appInfo } from "@limitless/images";
import { useWebSockets } from "@limitless/common/hooks/web-sockets/WebSocketsContext";
import { useExpertProfileContext } from "../../../../expert";
import { useTranslation } from "@limitless/common/hooks";
const useStyles = makeStyles({
  card: {
    width: 400,
    overflow: "auto"
  },
  media: {
    height: 0,
    paddingTop: "56.25%" // 16:9
  }
});
const InfoDialog = ({
  open,
  setOpen
}) => {
  const {
    wsStatus,
    forceDisconnect,
    forceReconnect
  } = useWebSockets();
  const classes = useStyles({
    wsStatus
  });
  const {
    t
  } = useTranslation();
  const {
    profile
  } = useExpertProfileContext();
  const handleCloseDialog = () => {
    setOpen(false);
  };
  const toggleWebSockets = () => {
    if (wsStatus === "disconnected") {
      forceReconnect();
    } else {
      forceDisconnect();
    }
  };
  const getScriptName = () => {
    let scriptName = "";
    try {
      const scripts = document.getElementsByTagName("script");
      scriptName = scripts[0].src.substring(scripts[0].src.lastIndexOf("/") + 1);
    } catch (error) {
      scriptName = "";
    }
    return scriptName;
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    onClose: handleCloseDialog,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description",
    scroll: "paper",
    disablePortal: false
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes.card
  }, /*#__PURE__*/React.createElement(CardMedia, {
    className: classes.media,
    image: appInfo,
    title: "Expert Web App"
  }), /*#__PURE__*/React.createElement(DialogTitle, {
    id: "alert-dialog-title"
  }, t("Application Information")), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(Table, {
    className: classes.table
  }, /*#__PURE__*/React.createElement(TableBody, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "Portal Name "), /*#__PURE__*/React.createElement(TableCell, null, " ", process.env.REACT_APP_NAME)), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "Version "), /*#__PURE__*/React.createElement(TableCell, null, " ", process.env.REACT_APP_VERSION)), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "Stage"), /*#__PURE__*/React.createElement(TableCell, null, " ", process.env.REACT_APP_STAGE)), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "User Name"), /*#__PURE__*/React.createElement(TableCell, null, " ", profile.userName)), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "Expert Inactivity Timeout "), /*#__PURE__*/React.createElement(TableCell, null, distanceInWords(new Date(), addMilliseconds(new Date(), process.env.REACT_APP_IDLE_TIME_EXPERT)))), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "Manager Inactivity Timeout "), /*#__PURE__*/React.createElement(TableCell, null, distanceInWords(new Date(), addMilliseconds(new Date(), process.env.REACT_APP_IDLE_TIME_MANAGER)))), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "HTTP Timeout "), /*#__PURE__*/React.createElement(TableCell, null, process.env.REACT_APP_HTTP_POST_TIMEOUT === "0" ? "Unlimited" : process.env.REACT_APP_HTTP_POST_TIMEOUT)), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "Log Level "), /*#__PURE__*/React.createElement(TableCell, null, " ", process.env.REACT_APP_LOG_LEVEL)), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "Script "), /*#__PURE__*/React.createElement(TableCell, null, getScriptName(), " ")), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "Web Sockets Active"), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Switch, {
    checked: wsStatus === "disconnected" ? false : true,
    onChange: () => {
      handleCloseDialog();
      toggleWebSockets();
    },
    name: "webSocketsSwitch"
  })))))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleCloseDialog,
    color: "secondary",
    id: "closeAppInfo"
  }, t("Close")))));
};
InfoDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func
};
export default InfoDialog;